import {styled} from '@mui/styles';
import React, {useCallback, useState} from 'react';
import ConfirmedDate from './ConfirmedDate';
import YesNoSwitch from './YesNoSwitch';

const Holder = styled('span')(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-start',
  gap: theme.spacing(4),

  '&.confirming': {
    opacity: 0.5,
    pointerEvents: 'none',
  }
}));

const ConfirmDate = ({order, field, service, onUpdated}) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const handleConfirm = useCallback((confirmed) => {
    setIsConfirming(true);
    const data = {...order}
    data[`${field}_confirmed`] = confirmed;
    service(data).then(updated => {
      onUpdated(updated)
      setIsConfirming(false);
    }).catch(() => setIsConfirming(false));
  }, [field, order, service, onUpdated]);

  return (
    <Holder {...(isConfirming ? {className: 'confirming'} : {})}>
      {order[field] ? (<>
        <ConfirmedDate date={order[field]} confirmed={order[`${field}_confirmed`]} showLabel={false}/>
        <YesNoSwitch checked={order[`${field}_confirmed`]} setChecked={handleConfirm} label="Confirmed" small/>
      </>) : '-'}
    </Holder>
  );
}

export default ConfirmDate;
